(function () {
  const STORAGE_DESKTOP = 'outveil:collectionColumnsDesktop';
  const STORAGE_MOBILE = 'outveil:collectionColumnsMobile';

  function colsRegex(kind) {
    return kind === 'desktop' ? /^grid--(\d+)-col-desktop$/ : /^grid--(\d+)-col-tablet-down$/;
  }

  function currentCols(grid, kind) {
    const re = colsRegex(kind);
    for (const cls of grid.classList) {
      const match = cls.match(re);
      if (match) return match[1];
    }
    return null;
  }

  function setGridCols(grid, kind, value) {
    const re = colsRegex(kind);
    Array.from(grid.classList).forEach((cls) => {
      if (re.test(cls)) grid.classList.remove(cls);
    });
    grid.classList.add('grid--' + value + (kind === 'desktop' ? '-col-desktop' : '-col-tablet-down'));
  }

  function updateActiveButtons(grid) {
    const desktopVal = currentCols(grid, 'desktop');
    const mobileVal = currentCols(grid, 'mobile');

    document.querySelectorAll('[data-cols-desktop]').forEach((btn) => {
      const active = btn.getAttribute('data-cols-desktop') === desktopVal;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    document.querySelectorAll('[data-cols-mobile]').forEach((btn) => {
      const active = btn.getAttribute('data-cols-mobile') === mobileVal;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function readStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      /* localStorage unavailable (private mode, blocked, etc.) */
    }
  }

  function syncView() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const storedDesktop = readStorage(STORAGE_DESKTOP);
    const storedMobile = readStorage(STORAGE_MOBILE);

    if (storedDesktop) setGridCols(grid, 'desktop', storedDesktop);
    if (storedMobile) setGridCols(grid, 'mobile', storedMobile);

    updateActiveButtons(grid);
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-cols-desktop], [data-cols-mobile]');
    if (!button) return;

    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const desktopValue = button.getAttribute('data-cols-desktop');
    const mobileValue = button.getAttribute('data-cols-mobile');

    if (desktopValue) {
      setGridCols(grid, 'desktop', desktopValue);
      writeStorage(STORAGE_DESKTOP, desktopValue);
    }

    if (mobileValue) {
      setGridCols(grid, 'mobile', mobileValue);
      writeStorage(STORAGE_MOBILE, mobileValue);
    }

    updateActiveButtons(grid);
  });

  function init() {
    syncView();

    const container = document.getElementById('ProductGridContainer');
    if (container && window.MutationObserver) {
      new MutationObserver(syncView).observe(container, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
